// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  bar: "ShareStrokes__bar",
  barLine: "ShareStrokes__barLine",
  outlined: "ShareStrokes__outlined",
  size: "ShareStrokes__size",
  sizeBarEnd: "ShareStrokes__sizeBarEnd",
  sizeUp: "ShareStrokes__sizeUp",
  track: "ShareStrokes__track",
};
